import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const uncheckedIconComponent = {
  root: 'unchecked-icon.root',
} as const satisfies ComponentLocatorMap;
